import React from 'react';

import Routes from './routes/Routes';
// [AUTH0 COMMENTED OUT] import Auth0ProviderWithHistory from './auth/auth0-provider-with-history';
import { BrowserRouter as Router } from 'react-router-dom';
import { ProductColorProvider } from './utils/productColorContext';

export default function App() {
  return (
    <ProductColorProvider>
      {/* [AUTH0 COMMENTED OUT] Auth0ProviderWithHistory wrapper removed — using newlogin system */}
      {/* <Auth0ProviderWithHistory> */}
        <Router basename={process.env.PUBLIC_URL}>
          <Routes />
        </Router>
      {/* </Auth0ProviderWithHistory> */}
    </ProductColorProvider>
  );
}
